module.exports = __webpack_public_path__ + "static/media/exercicio2.3a921712.png";